import React from 'react'
import HeroSectionImage from "../assets/HeroSectionImage.jpg";
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <>
    <div className="bg-cover bg-center h-screen" style={{backgroundImage: `url(${HeroSectionImage})`}} >
        
  <div className="flex items-center justify-center h-full bg-black bg-opacity-50">
    <div className="text-center text-white">
      <h1 className="text-5xl font-bold">Welcome to OZ Wide Cover</h1>
      <p className="mt-4 text-xl">Stay Covered, Stay Confident.</p>
      <p className="mt-4 text-xl">Insure your ride, Secure your Future.</p>
      <div className='flex justify-center items-center gap-5'>
      <Link to="/quote" className="px-6 py-3 border border-[#c8a876] mt-4 text-white font-medium cursor-pointer rounded-md hover:bg-[#c09858]  transition duration-200">
        Get a Quote
      </Link>
      <Link to="tel:0452322420" className="px-6 py-3 border border-[#c8a876] mt-4 text-white font-medium cursor-pointer rounded-md hover:bg-[#c09858]  transition duration-200">Call us</Link>
      </div>
    </div>
  </div>
</div>

    </>
  )
}

export default HeroSection
